import TextLink, { LocaleAwareLink } from './TextLink'

export default TextLink
export { LocaleAwareLink }
